'use strict';

angular.module('DoohApps')
    .directive('copyUrlClipboard', ['$rootScope','$location', '$uibModal', '$uibModalStack', 'DialogHandler', 'DoohConfig',
        function ($rootScope, $location, $uibModal, $uibModalStack, DialogHandler, DoohConfig) {
              
    return {
        restrict: 'A',
        scope: {
            copyUrlClipboard: '=',
            buttonText: '@?',
            postCopyAction: '&?',
            showFailPopup: '=?'
        },
        link: function (scope, element, attrs) {
            if (angular.isUndefined(scope.showFailPopup))
                scope.showFailPopup = true;

            var successMsg = 'URL copied to clipboard';
            var urlRegExp = new RegExp('^(?:[a-z]+:)?//', 'i');
            var getUrl = function (url) {
                if (urlRegExp.test(url))
                    return url;

                return `${DoohConfig.storeBaseUrl}/#/${url}`;
            }

            var copyToClipboardFail = function (text) {
                DialogHandler.AddError('Could not copy to clipboard!');
                if (text != undefined && scope.showFailPopup) {
                    scope.modal = new ModalHandler($rootScope, scope, $uibModal);
                    if (scope.modal.open('ClipboardFail', 'appSharePopup'))
                        scope.linkToClient = text;
                }
            }

            scope.close = function () {
                scope.modal.close('ClipboardFail');
            }

            var copyToClipboardSuccess = function () {
                if (scope.postCopyAction)
                    scope.postCopyAction();
                DialogHandler.AddMessage(successMsg);
            }
                        
            scope.buttonText = scope.buttonText || 'Copy';
            
            element.bind('click', function () {
                
                var url = getUrl(scope.copyUrlClipboard);
                var targetElem = document.createElement('a');
                                          
                var clipboard = new Clipboard(targetElem, {
                    text: function () {
                        return url;
                    }
                });
                clipboard.on('success', function (e) {
                    copyToClipboardSuccess();
                });
                clipboard.on('error', function (e) {
                    copyToClipboardFail(url);
                });

                targetElem.click();
                clipboard.destroy();
            });
        },
        templateUrl: '/../Templates/Partials/Templates/CopyToClipboardTemplate.html?v=' + DoohConfig.version
        
    }
}]);
